(function(){

  var envDPR          = window.devicePixelRatio;
  var imageContainers = document.querySelectorAll('.js-auto-img-src');
  var useSource;

  Array.prototype.forEach.call(imageContainers, function(el) {
    var imageSource1x = el.dataset.bgImgPathOnex;
    var imageSource2x = el.dataset.bgImgPathTwox;

    if (envDPR >= 1.5) {
      useSource = imageSource2x;
    } else {
      useSource = imageSource1x;
    }

    el.style.backgroundImage = 'url(' + useSource + ')';
  });

})();
